import { getQueryMethod, resources, entities, methods, getURLParams } from '../utils';
const { meloAPI } = resources;
const { purchases } = entities;
const { POST, PATCH } = methods;

const query = getQueryMethod(meloAPI, purchases);

const endpoints = {
  createPurchase: async body => {
    return await query('', POST, body);
  },
  getPurchase: async purchaseId => {
    return await query(purchaseId);
  },
  getPurchasesPaginated: async ({ businessId, ...params }) => {
    const queryParams = getURLParams(params);
    return await query(`get-many/${businessId}?${queryParams}`);
  },
  updatePurchase: async (businessId, purchaseId, purchaseData) => {
    return await query('update-one', PATCH, { businessId, purchaseId, ...purchaseData });
  },
  updatePurchases: async (businessId, purchases) => {
    return await query('update-many', PATCH, { businessId, purchases });
  },
  deletePurchases: async purchasesIds => {
    return await query('delete-many', PATCH, purchasesIds);
  },
  markPurchasesAsPayed: async (businessId, purchases) => {
    return await query('payments/mark', POST, { businessId, purchases });
  },
  payPurchases: async body => {
    return await query('payments/pay', POST, body);
  },
  getPurchasesPayoutVoucher: async (businessId, payoutId) => {
    return await query(`payments/voucher/payout/${businessId}/${payoutId}`);
  },
  getPurchasePayoutVoucher: async (purchaseId, paymentId) => {
    const queryParams = paymentId ? `?${getURLParams({ paymentId })}` : '';
    return await query(`payments/voucher/purchase/${purchaseId}${queryParams}`);
  },
  getSupplierPayoutVoucher: async (businessId, payoutId, supplierId) => {
    return await query(`payments/voucher/supplier/${businessId}/${payoutId}/${supplierId}`);
  },
  getPurchasesByIds: async purchasesIds => {
    const queryParams = getURLParams({ purchasesIds });
    return await query(`get-by/ids?${queryParams}`);
  },
  sendInternationalNotification: async body => {
    return await query('payments/notify-international', POST, body);
  }
};

export default endpoints;
